






















import { Component, Vue, Prop } from "vue-property-decorator";
import { Zhiyijilu } from "@/request/sjzx";
import JiluRender from "../components/jilu-render.vue";
@Component({
  components: {
    JiluRender,
  },
})
export default class ZhiyijiluDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private zhenci: any;
  private jilus: any = [];
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  /**
   * @description 获得质疑记录
   */
  private getZhiyijilu() {
    const params: any = {
      params: {
        zhenci_id: this.zhenci.zhenci_id,
      },
    };
    Zhiyijilu(this, params).then((data: any) => {
      data.forEach((item: any) => {
        item.ifShowDetail = true;
        item.action = "质疑";
      });
      this.jilus = data;
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getZhiyijilu();
  }
}
